module.exports = __webpack_public_path__ + "vue/img/icon-07.2beae009.png";